import { BuildDetailsGroupArray } from '../../components/build-details/types';
import { selectors } from '../../ducks/buildDetailsFilterBar';
import { BuildDetailsDiffFragFragment } from '../../graphql/__generated__/graphql';

export enum VisualWorkerMessageType {
  BuildGroups
}

/**
 * Structure for the request params and response type for a message sent to the worker. Additional
 * can be added by adding an enum, and supplying a params / response value for each.
 */
export type VisualWorkerMessage = {
  [VisualWorkerMessageType.BuildGroups]: {
    params: {
      nodes: BuildDetailsDiffFragFragment[],
      filterValues: ReturnType<typeof selectors.buildDetailsFilterValues>,
    },
    response: {
      groups: BuildDetailsGroupArray;
      diffIds: string[];
    }
  }
}

export type VisualWorkerParams<T extends VisualWorkerMessageType> = VisualWorkerMessage[T]['params'];
export type VisualWorkerResponse<T extends VisualWorkerMessageType> = VisualWorkerMessage[T]['response'];

type ParamType<T extends VisualWorkerMessageType> = {
  type: T;
  data: VisualWorkerParams<T>;
  id: string;
};
type ResponseType<T extends VisualWorkerMessageType> = {
  type: T;
  data: VisualWorkerResponse<T>;
  id: string;
};

export type VisualWorkerMessageParams = ParamType<VisualWorkerMessageType>
export type VisualWorkerMessageResponse = ResponseType<VisualWorkerMessageType>;
